import Footer from "@/components/layout/Footer";
import { useAuth } from "@/context/AuthContext";
import { useCampaign } from "@/context/CampaignContext";
import {
  ArrowRight,
  CheckCircle2,
  Search,
  Sparkles,
  Target,
  Users
} from "lucide-react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import {
  parseIntent,
  searchPeople,
} from "../../Redux/ReduxSlices/newAppoloApiSlice";
import { peoplePerPage } from "../../utils/perPageValue";
import SearchLoader from "../customeLoader/SearchLoader";
import PromptData from "./PromptData";

export default function ResultsList() {
  const {
    promptsDataCompany,
    setViewMode,
    promptsDataPeople,
    viewMode,
    setPromptsDataCompany,
    setPromptsDataPeople,
    setShowPromtData,
    setShowUrlData,
    showPromtData,
    isSearchLoading,
    setIsSearchLoading,
    loadingMessage,
    setLoadingMessage,
    promptInput,
    setPromptInput,
  } = useAppContext();

  const { setSelectedRecipients } = useCampaign();
  const { user } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePromptSearch = async () => {
    const promptInput = promptInput;
    // localStorage.getItem("lastPrompt");
    if (!promptInput) return;

    try {
      setIsSearchLoading(true);
      setLoadingMessage({
        title: "Searching our database...",
        subtitle: "Looking through existing leads and company data.",
      });

      const sessionId = localStorage.getItem("sessionId");

      const parseRes = await dispatch(
        parseIntent({
          user_id: user?.id || "test_user",
          session_id: sessionId,
          prompt: promptInput.trim(),
          use_goapi: true,
        })
      ).unwrap();

      const dbResults = await dispatch(
        searchPeople({
          parseIntentData: parseRes,
          page: 1,
          per_page: peoplePerPage,
        })
      ).unwrap();

      if (!dbResults || dbResults.length === 0) {
        setLoadingMessage({
          title: "Expanding your search...",
          subtitle: "Searching intelligently to uncover more opportunities...",
        });

        // 🔹 Optional fallback: run a wider web-based search
        const webResults = await dispatch(
          searchPeople({
            parseIntentData: parseRes,
            page: 1,
            per_page: peoplePerPage,
          })
        ).unwrap();

        setPromptsDataPeople(webResults);
      } else {
        setPromptsDataPeople(dbResults);
      }

      setViewMode("people");
      setShowPromtData(true);
      setShowUrlData(false);
      navigate("/search");
    } catch (error) {
      console.error("❌ Prompt search failed:", error);
    } finally {
      setIsSearchLoading(false);
    }
  };

  if (isSearchLoading) {
    return (
      <SearchLoader
        title={loadingMessage?.title}
        subtitle={loadingMessage?.subtitle}
      />
    );
  }

  const examplePrompts = [
    "General Manager of Hotels and Resorts in USA",
    "Importers of Home Décor",
    "Founder / Co-Founder / CEO of startups in India",
    "Senior Interior Designer in India",
  ];

  const handlePromptClick = (prompt) => { };

  return (
    <div className="space-y-3 w-full r">
      {/* Show empty message when nothing to show */}
      {!showPromtData && !isSearchLoading && (
        // <div className="min-h-[500px] flex flex-col items-center justify-center px-6 py-12 text-center">
        //   {/* Animated Icon Container */}
        //   <div className="relative mb-8">
        //     <div className="w-20 h-20 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl flex items-center justify-center border border-blue-100 shadow-sm">
        //       <div className="relative">
        //         <Search className="w-6 h-6 text-blue-600" />
        //         <Sparkles className="w-3 h-3 text-blue-400 absolute -top-1 -right-1" />
        //       </div>
        //     </div>

        //     {/* Decorative Elements */}
        //     <div className="absolute -top-3 -right-3 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shadow-sm">
        //       <Target className="w-5 h-5 text-blue-500" />
        //     </div>
        //     <div className="absolute -bottom-3 -left-3 w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center shadow-sm">
        //       <Users className="w-5 h-5 text-indigo-500" />
        //     </div>
        //   </div>

        //   {/* Text Content */}
        //   <div className="max-w-2xl mx-auto">
        //     <h3 className=" mb-4 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
        //       Discover Your Perfect Leads
        //     </h3>
        //     <p className="text-lg text-gray-600 mb-6 leading-relaxed">
        //       Describe your ideal customers or provide a website URL to find
        //       relevant leads and company data with precision.
        //     </p>

        //     {/* Example Prompts Section */}
        //     <div className="mb-8">
        //       <div className="flex items-center justify-center gap-2 mb-4">
        //         <div className="w-4 h-0.5 bg-blue-200"></div>
        //         <span className="text-sm font-medium text-gray-500">
        //           TRY THESE EXAMPLES
        //         </span>
        //         <div className="w-4 h-0.5 bg-blue-200"></div>
        //       </div>

        //       <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto">
        //         {examplePrompts.map((prompt, index) => (
        //           <button
        //             key={index}
        //             onClick={() => setPromptInput(prompt)}
        //             className="group p-4 text-left bg-white border border-gray-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all duration-200 hover:translate-y-[-2px]"
        //           >
        //             <div className="flex items-start gap-3">
        //               <div className="w-6 h-6 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-blue-100 transition-colors">
        //                 <ArrowRight className="w-3 h-3 text-blue-500" />
        //               </div>
        //               <span className="text-sm text-gray-700 group-hover:text-gray-900 leading-relaxed">
        //                 {prompt}
        //               </span>
        //             </div>
        //           </button>
        //         ))}
        //       </div>
        //     </div>
        //   </div>
        // </div>

        <div className="flex min-h-[430px] items-center justify-center px-4 py-20 max-md:py-12">
          <div className="relative w-full max-w-4xl overflow-hidden sm:p-8">
            <div className="relative z-10">
              {/* Top content */}
              <div className="flex flex-col items-center text-center">
                <div className="relative mb-5">
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-200">
                    <Search className="h-7 w-7" />
                  </div>

                  <div className="absolute -right-3 -top-3 max-md:-top-0 flex h-8 w-8 items-center justify-center rounded-xl border-4 border-white bg-blue-100 text-blue-600">
                    <Sparkles className="h-4 w-4" />
                  </div>

                  <div className="absolute -bottom-2 -left-3 flex h-8 w-8 items-center justify-center rounded-xl border-4 border-white bg-indigo-100 text-indigo-600">
                    <Users className="h-4 w-4" />
                  </div>
                </div>

                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-blue-100 bg-white px-3 py-1.5 text-xs font-semibold text-blue-700 shadow-sm">
                  <Target className="h-3.5 w-3.5" />
                  AI-Powered Lead Search
                </div>

                <h3 className="mb-0 text-xl font-bold tracking-tight text-gray-900 ">
                  Discover Your Perfect Leads
                </h3>

                <p className="mt-3 max-w-2xl text-sm leading-6 text-gray-600 sm:text-base">
                  Describe your ideal customers, job roles, industries, locations, or
                  paste a website URL to find relevant business leads.
                </p>
              </div>

              {/* Search preview */}
              <div className="mx-auto mt-6 flex max-w-2xl items-center gap-3 rounded-2xl border border-blue-100 bg-white p-3 shadow-sm">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
                  <Search className="h-4 w-4" />
                </div>

                <p className="min-w-0 flex-1 truncate text-left text-sm text-gray-500">
                  Purchase managers at luxury hotels in India
                </p>

                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-600 text-white">
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>

              {/* Example prompts */}
              <div className="mt-7">
                <div className="mb-4 flex items-center justify-center gap-3">
                  <div className="h-px w-10 bg-blue-200" />

                  <span className="text-xs font-semibold uppercase tracking-[0.15em] text-gray-400">
                    Try an example
                  </span>

                  <div className="h-px w-10 bg-blue-200" />
                </div>

                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  {examplePrompts.map((prompt, index) => (
                    <button
                      key={`${prompt}-${index}`}
                      type="button"
                      onClick={() => setPromptInput(prompt)}
                      className="group flex items-center gap-3 rounded-2xl border border-gray-200 bg-white/90 p-3.5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md"
                    >
                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-50 text-gray-400 transition-colors group-hover:bg-blue-50 group-hover:text-blue-600">
                        <Target className="h-4 w-4" />
                      </div>

                      <span className="min-w-0 flex-1 text-sm leading-5 text-gray-700">
                        {prompt}
                      </span>

                      <ArrowRight className="h-4 w-4 shrink-0 text-gray-300 transition-all group-hover:translate-x-1 group-hover:text-blue-600" />
                    </button>
                  ))}
                </div>
              </div>

              {/* Bottom indicators */}
              <div className="mt-6 flex flex-wrap items-center justify-center gap-4 border-t border-blue-100/80 pt-5 text-xs font-medium text-gray-500">
                <span className="inline-flex items-center gap-1.5">
                  <CheckCircle2 className="h-4 w-4 text-green-500" />
                  Targeted results
                </span>

                <span className="inline-flex items-center gap-1.5">
                  <CheckCircle2 className="h-4 w-4 text-green-500" />
                  Verified business data
                </span>

                <span className="inline-flex items-center gap-1.5">
                  <CheckCircle2 className="h-4 w-4 text-green-500" />
                  Ready for outreach
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Actual data */}
      {showPromtData && <PromptData />}

      <div className="pt-8">
        <Footer />
      </div>
    </div>

  );
}
